import {
    SET_CONTACT_TYPE_LOADING,
    REMOVE_CONTACT_TYPE_LOADING,
    GET_CONTACT_TYPE,
    GET_CONTACT_TYPE_CONTACTS,
    REMOVE_CONTACT_TYPE
} from "../types";

const initialState = {
    loading: false, // Initit loading state
    typeData: {}, // ATTN: This is the contact being viewed or edited ... Might want a better name
    oldValue: ""
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_CONTACT_TYPE_LOADING:
            return {
                ...state,
                loading: true
            };
        case REMOVE_CONTACT_TYPE_LOADING:
            return {
                ...state,
                loading: false
            };
        case GET_CONTACT_TYPE:
            return {
                ...state,
                typeData: { ...payload }
            };
        case GET_CONTACT_TYPE_CONTACTS:
            return {
                ...state,
                contacts: { ...payload }
            };
        case REMOVE_CONTACT_TYPE:
            return {
                ...state,
                typeData: {}
            };
        default:
            return state;
    }
}